import { State } from './model';
import {
  CallStatusDefault,
  Groups,
  SelectMode,
  UserInfoDefault,
} from '../../../models';

export const StateDefault: State = {
  keys: [],
  groupedBy: Groups.DEVICES,
  mode: SelectMode.All,
  assignCall: { ...CallStatusDefault },
  unassignCall: { ...CallStatusDefault },
  getCustomerCall: { ...CallStatusDefault },
  addressee: { ...UserInfoDefault },
  isConfirmed: false
};

export default StateDefault;
